import UserAddAccountForm from './UserAddAccountForm';

export default UserAddAccountForm;
